/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bidbattle__Status__Stopped7Inputs */

const en_bidbattle__status__stopped7 = /** @type {(inputs: Bidbattle__Status__Stopped7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stopped`)
};

/**
* | output |
* | --- |
* | "Stopped" |
*
* @param {Bidbattle__Status__Stopped7Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const bidbattle__status__stopped7 = /** @type {((inputs?: Bidbattle__Status__Stopped7Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bidbattle__Status__Stopped7Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_bidbattle__status__stopped7(inputs)
});
export { bidbattle__status__stopped7 as "bidbattle__status__STOPPED" }